import React from "react";
import { useNavigate } from "react-router-dom";
import { Settings as SettingsIcon } from "lucide-react";

export const PageShell = ({ children, showSettings = false, className = "" }) => {
  const navigate = useNavigate();
  return (
    <div className={`min-h-screen px-6 well-page-enter ${className}`}>
      {showSettings && (
        <button
          onClick={() => navigate("/settings")}
          aria-label="Settings"
          data-testid="topbar-settings-btn"
          className="fixed top-6 right-6 z-40 w-11 h-11 bg-white/50 backdrop-blur-xl border border-white/40 rounded-full flex items-center justify-center shadow-[0_4px_16px_rgba(0,0,0,0.06)] text-[#2A3B32] hover:bg-white/60 transition-colors"
        >
          <SettingsIcon size={20} strokeWidth={1.5} />
        </button>
      )}
      {children}
    </div>
  );
};

export default PageShell;
